"use strict";

/**
 * Keys for cross-portal settings.
 *
 * If you need a key that can differ across portals, see
 * crm_data/settings/UserPortalSettingsKeys.js
 *
 * Key should be defined in ABC order as...
 *
 *  export const KEY_NAME = 'key';
 */
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _CRMToContactsObjectTypes = _interopRequireDefault(require("crm_data/constants/CRMToContactsObjectTypes"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _portalId = _hubspot.default.get();

var MAJOR_OBJECT_TYPES = [_ObjectTypes.CONTACT, _ObjectTypes.COMPANY, _ObjectTypes.DEAL, _ObjectTypes.TICKET, _ObjectTypes.VISIT];
var BOARD_OBJECT_TYPES = [_ObjectTypes.DEAL, _ObjectTypes.TASK, _ObjectTypes.TICKET];
var NPS_SURVEY_OBJECT_TYPE = 'NPS_SURVEY';
var UserSettingsKeys = {
  CLOSE_COUNT_IMPORT_KB_MODAL: ['closed-import-kb-modal'],
  // todo - this isnt related to queues
  DONT_SHOW_FOLLOW_UP_TASK: ['Tasks', 'Queues', 'FollowUpTasks', 'hide'],
  EMAIL_COMMUNICATOR_TRACKING_TOOLTIP_SHOWN: ['has-viewed-email-communicator-tracking-tooltip'],
  // This setting really belongs in UserPortalSettingsKey, but the format is not correct
  GOOGLE_CALENDAR: ["integrations:google-calendar-v2:portal-" + _portalId],
  HAS_CLOSED_KILL_SENDGRID_ALERT: ['has-closed-kill-sendgrid-alert'],
  HAS_COLLAPSED_RIGHT_SIDEBAR: ['has-collapsed-right-sidebar'],
  HAS_COMPLETED_INDEX_ONBOARDING: ['CRM', 'Index', 'Onboarding'],
  HAS_COMPLETED_RECORD_ONBOARDING: ['CRM', 'ObjectRecord', 'Onboarding'],
  HAS_SEEN_PINNED_NOTE: ['CRM', 'hasSeenNotePopover'],
  HAS_VIEWED_DEAL_EMPTY_STATE: ['Deals', 'viewed', 'emptyState'],
  HAS_VIEWED_DEAL_STAGE_PROPERTIES_ONBOARDING: ['CRM', 'DealStageProperties', 'Onboarding'],
  HAS_VIEWED_IMPORT_UPDATE_SHEPHERD: ['has-viewed-import-update-shepherd'],
  HAS_VIEWED_IMPORT_CHANGE_BANNER: ['has-viewed-import-change-banner'],
  HAS_VIEWED_SMART_TASK_ONBOARDING: ['Tasks', 'SmartTasks', 'ViewedOnboarding'],
  HAS_VIEWED_TASKS_EMPTY_STATE: ['Tasks', 'viewed', 'emptyState'],
  HAS_CLOSED_THREAD_REPLY_MESSAGE: ['has-closed-ticket-reply-message'],
  HIDE_IMPORT_INFO_STEP: ['hide-import-info-step'],
  HIDE_MEETINGS_PRO_TIP: ['hide-meetings-pro-tip'],
  HIDE_QUOTES_SENDER_COMPANY_POPOVER: ['hide-quotes-sender-company-popover'],
  HIDE_QUOTE_EXPIRED_MODAL: ['hide-quotes-expired-modal'],
  HIDE_QUOTE_DRAFTED_MODAL: ['hide-quotes-drafted-modal'],
  QUOTES_TEMPLATE_PREFERENCE: ['quotes-template-preference'],
  JOB_TITLE: ['jobtitle'],
  LAST_DUPLICATES_SHEPHERD_ACTION: ['last-duplicates-shepherd-action'],
  LAST_COMPANY_DUPLICATES_SHEPHERD_ACTION: ['last-company-duplicates-shepherd-action'],
  LINKEDIN_SALES_NAVIGATOR: ['LINKEDIN_SALES_NAVIGATOR'],
  NPS_SETTINGS: [NPS_SURVEY_OBJECT_TYPE, 'nps_survey_completed'],
  PICKED_PORTAL: ['sidekick:user:picked:portal'],
  PICKED_PORTAL_MODAL: ['PickedPortalModal'],
  THREE_COLUMN_PROFILES_VIEWED: ['3-column-profiles-viewed'],
  VIEW_ALL_PROPERTIES_CLICKED: ['view-all-properties-clicked'],
  VIDEO_INTEGRATION_HAS_CREATED_VIDEO: ['video-integration-has-created-video'],
  HAS_CHECKED_ASSOCIATION_DEAL_BOX_CONTACT: ['has-checked-association-deal-box-contact'],
  HAS_CHECKED_ASSOCIATION_DEAL_BOX_COMPANY: ['has-checked-association-deal-box-company'],
  HAS_CHECKED_ASSOCIATION_TICKET_BOX_CONTACT: ['has-checked-association-ticket-box-contact'],
  HAS_CHECKED_ASSOCIATION_TICKET_BOX_COMPANY: ['has-checked-association-ticket-box-company']
};
MAJOR_OBJECT_TYPES.forEach(function (objectType) {
  UserSettingsKeys["PROFILE_SIDEBAR_" + objectType] = [_CRMToContactsObjectTypes.default[objectType], 'sidebar_settings']; // DEPRECATION NOTICE This key can be removed when we do not have a two
  // column profile anymore

  UserSettingsKeys["PROFILE_SIDEBAR_" + objectType + "_ORDER"] = [_CRMToContactsObjectTypes.default[objectType], 'sidebar_order'];
  UserSettingsKeys["PROFILE_RIGHT_SIDEBAR_" + objectType + "_ORDER"] = [_CRMToContactsObjectTypes.default[objectType], 'right_sidebar_order'];
  UserSettingsKeys["PROFILE_LEFT_SIDEBAR_" + objectType + "_ORDER"] = [_CRMToContactsObjectTypes.default[objectType], 'left_sidebar_order'];
});
BOARD_OBJECT_TYPES.forEach(function (objectType) {
  UserSettingsKeys[objectType + "_VIEWTYPE_DEFAULT"] = ["" + objectType, 'viewtype', 'default'];
});
/* Formats like "Contacts:sidebar_settings" */

Object.keys(UserSettingsKeys).forEach(function (key) {
  var value = UserSettingsKeys[key];
  UserSettingsKeys[key] = "" + value.join(':');
});
var _default = UserSettingsKeys;
exports.default = _default;
module.exports = exports.default;